import { useEffect, useRef, useState } from 'react';

import useDeviceType, { MOBILE_SCREEN } from '@travel/traveler-core/hooks/useDeviceType';

import { MOBILE_HEADER_HEIGHT } from 'components/Header/useCustomFixedStyling';

function useMapOffsetYPosition() {
  const isMobile = useDeviceType() === MOBILE_SCREEN;

  const [offsetY, setOffsetY] = useState(0);
  const [isFullScreen, setIsFullScreen] = useState(false);

  const shouldDetectFullScreenRef = useRef(false);

  useEffect(() => {
    const handleMapAppearance = () => {
      if (!shouldDetectFullScreenRef.current && window.pageYOffset > window.innerHeight / 2) {
        shouldDetectFullScreenRef.current = true;
      }

      // Cases to set fullscreen map
      // 1. when the map is almost fullscreen, the gap value should be less than the offset to detect fullscreen
      // 2. when the list has fully overlapped the map once
      if (
        shouldDetectFullScreenRef.current &&
        (window.pageYOffset < 10 || window.pageYOffset > window.innerHeight + MOBILE_HEADER_HEIGHT)
      ) {
        setOffsetY(0);
        setIsFullScreen(true);
      } else if (!isFullScreen) {
        const mapTopMargin = 60;
        const searchBarHeight = 54;
        const mapArea =
          window.innerHeight - window.pageYOffset + MOBILE_HEADER_HEIGHT + searchBarHeight;

        // Note: centering the center of the fullscreen map on the Map's displayed area by calculating from the spacing between list and top bar
        // Note2: We are using transform instead of height transition due to performance matter
        setOffsetY(
          -window.innerHeight + (mapArea + mapTopMargin + (window.innerHeight / 2 - mapArea / 2)),
        );
      }
    };

    if (!isFullScreen && isMobile) {
      document.addEventListener('scroll', handleMapAppearance);
    }

    return () => {
      if (isMobile) {
        document.removeEventListener('scroll', handleMapAppearance);
      }
    };
  }, [isFullScreen, isMobile, offsetY]);

  return offsetY;
}

export default useMapOffsetYPosition;
